export const questions = {
  question: 'Leaving without your insurance?',
  helper: 'Tell us why to help us improve.',
  options: [
    {
      label: `I already have auto insurance`,
      name: 'already_have_auto_insurance',
    },
    {
      label: `I already have renters insurance`,
      name: 'already_have_renters_insurance',
    },
    {
      label: `I want to bundle with my current provider`,
      name: 'bundle_provider',
    },
    {
      label: `I’m not ready to buy yet`,
      name: 'not_read_to_buy',
    },
    {
      label: `I don’t trust this site`,
      name: 'dont_trust_site',
    },
    {
      label: `I want to see more options before buying`,
      name: 'more_options',
    },
  ],
};

export const initiallyCheckedItems = questions.options.reduce(
  (names, { name }) => (name !== 'other' ? names.concat(name) : names),
  []
);
